import DescriptionStep from './DescriptionStep.tsx';
import type { DescriptionStepInput } from './DescriptionStep.validation.ts';
import type { StepConfig } from 'components/technical/wizard/StepConfig.tsx';
import type { NotVerifiedAssetWithId } from 'components/market/asset/AssetService.tsx';

export const config = ({
  goToNextStep,
  availableCollateral,
  availableUnderlyingAssets,
}: {
  goToNextStep: () => void;
  availableCollateral: NotVerifiedAssetWithId[];
  availableUnderlyingAssets: NotVerifiedAssetWithId[];
}): StepConfig<DescriptionStepInput> => ({
  label: 'Description',
  element: (
    <DescriptionStep
      goToNextStep={goToNextStep}
      availableCollateral={availableCollateral}
      availableUnderlyingAssets={availableUnderlyingAssets}
    />
  ),
  fields: ['name', 'description', 'useUnderlying'],
});
